import { Component, OnInit, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CategoryHOF } from '../category';

@Component({
    selector: 'app-edit-categoryHOF-dialog',
    templateUrl: './edit-categoryHOF-dialog.component.html',
    styleUrls: ['./edit-categoryHOF-dialog.component.scss'],
})
export class EditCategoryHOFDialogComponent implements OnInit {
    title = 'Category Editor';
    category: CategoryHOF;
    categoryNames: string[];
    categoryHOFEditorForm: FormGroup;
    isCategoryUpdated: boolean;

    // Getters for form validation error messages
    get Name(): AbstractControl {
        return this.categoryHOFEditorForm.controls.Name;
    }

    constructor(
        private dialogRef: MatDialogRef<EditCategoryHOFDialogComponent>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: { category: CategoryHOF; categoryNames: string[]; title: string }
    ) {
        this.category = data.category;
        this.categoryNames = data.categoryNames;
    }

    ngOnInit(): void {
        this.categoryHOFEditorForm = this.formBuilder.group({
            Name: [
                this.category.categoryName,
                [Validators.required, isCategoryNameTaken(this.category.categoryName, this.categoryNames)],
            ],
            // Active: [this.category.active],
        });

        this.title = this.data.title;
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues: any): void {
        this.categoryHOFEditorForm.markAllAsTouched();

        if (this.categoryHOFEditorForm.valid) {
            this.category.categoryName = formValues.Name;

            this.dialogRef.close(this.category);
            this.categoryHOFEditorForm.reset();
        }
    }
}

/* Validation function to see if the inputted CategoryName already exists. If so, the field will become invalid.
 * This error will NOT occurr if, while editing an existing CategoryName, the user reverts changes to match the
 * original name provide to the form prior to saving.
 */
function isCategoryNameTaken(name: string, categoryNames: string[]): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        const isNameTaken = categoryNames.some((value) => value === control.value);
        const error = isNameTaken && control.dirty && control.value !== name ? { isNameTaken: true } : null;
        return error;
    };
}
